import  { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LogErrors } from './../../utilities/LogErrors'

//Funciones personalizadas
import { CheckAccessCode } from './../../utilities/BL/Logins'

//Funciones comunes
import { useLanguage } from './../../utilities/LanguageContext'

//Componentes comunes
import { Input } from './../Commons/Forms/Fields/Input'
import { Loading } from './../Commons/Loading'


const Login = () => {
  const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
  const navigate = useNavigate()

  //Estados
  const [formData, setFormData] = useState({ accessCode: '' }) // Estado que maneja la info del formulario
  const [errors, setErrors] = useState({}) // Estado que maneja los errores
  const [isSubmitted, setIsSubmitted] = useState(false) // Estado que controla si se ha enviado, o no, el formulario
  const [isLoading, setIsLoading] = useState(true) // Estado qude carga
  const [isButtonLoading, setIsButtonLoading] = useState(false)
  const [isAdminLoginButtonLoading, setIsAdminLoginButtonLoading] = useState(false)
  
  //Objetos que almacenan los controles del formulario
  const accessCodeRef = useRef(null)
  

  //--- Funciones personalizadas ---//
  const LoadPage = async () => {
    try {
      await SetMexicoTheme()

      //Establecer el tema claro a la web
      document.body.classList.remove('DarkTheme')

      document.getElementById("root").classList.add("BodyComplete")
    } catch (error) {
      await LogErrors('LoadPage - Login', error)
    } finally {
      setIsLoading(false)
    }
  }

  const GoToLogin = async (e) => {
    try {
      e.preventDefault()
      setIsButtonLoading(true)

      setIsSubmitted(true) // Marcar el formulario como enviado

      const response = await CheckAccessCode(formData)
      
      if (response.success) {
        if (response.data.linkServer !== '') {
          let URLToGo = ''
          
          if (response.data.linkServer.toLowerCase().includes('https://')) {
            URLToGo = response.data.linkServer
          } else {
            URLToGo = 'https://' + response.data.linkServer
          }

          window.location.href = URLToGo
        } else {
          const error = {
            errors: {
              accessCode: 'No ha sido posible validar el código de acceso que escribiste en el campo. Inténtalo nuevamente o inténtalo más tarde.'
            }
          }

          setErrors(error.errors) // Muestra los errores si los hay

          // Hacer focus en el campo correspondiente
          if (error.errors.accessCode) {
            accessCodeRef.current.focus()
          }

          setIsButtonLoading(false)
        }
      } else {
        setErrors(response.errors) // Muestra los errores si los hay

        // Hacer focus en el campo correspondiente
        if (response.errors.accessCode) {
          accessCodeRef.current.focus()
        }

        setIsButtonLoading(false)
      }
    } catch (error) {
      await LogErrors('GoToLogin - Login', error)  
    }
  }

  const GoToAdminLogin = async () => {
    try {
      setIsAdminLoginButtonLoading(true)

      const URLToGo = 'https://app.riactivos.com/login'
      window.location.href = URLToGo

      setIsAdminLoginButtonLoading(false)
    } catch (error) {
      await LogErrors('GoToAdminLogin - Login', error)  
    }
  }

  //--- Funciones para establecer el tema de Gobierno a la web ---//
  const SetRiactivosTheme = async () => {
    try {
      document.body.classList.remove('MexicoTheme')
    } catch (error) {
      await LogErrors('SetRiactivosTheme - Login', error)
    }
  }

  const SetMexicoTheme = async () => {
    try {
      document.body.classList.add('MexicoTheme')
    } catch (error) {
      await LogErrors('SetMexicoTheme - Login', error)
    }
  }
  //--- Funciones para establecer el tema de Gobierno a la web ---//
  //--- Funciones personalizadas ---//



  //--- Eventos de la página web ---//
  /**
   * Función para obtener la configuración, una vez que termine de cargarse el componente
   */
  useEffect(() => {
    LoadPage()
  },[]) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar
  //--- Eventos de la página web ---//



  //--- Eventos de formulario ---//
  /**
   * Función que se ejecuta cuando se realiza un cambio en el checkbox del formulario.
   * Obtiene la info de los campos del formulario y actualiza el valor del checkbox (True o False)
   * @param {Event} e 
   */
  const InputChange = async (e) => {
    try {  
      const { id, value, type, checked } = e.target
      
      setFormData({
        ...formData,
        [id]: type === 'checkbox' ? checked : value
      })
    } catch (error) {
      await LogErrors('InputChange - Login', error)
    }
  }

  /**
   * Función que se ejecuta cuando se presiona la tecla Enter o se presiona el botón del formulario
   * @param {Event} e 
   */
  const FormSubmit = async (e) => {
    try {
      await GoToLogin(e)
    } catch (error) {
      await LogErrors('FormSubmit - Login', error)
    }
  }

  /**
   * Función que se ejecuta al presiona la tecla Enter en el formulario
   * @param {Event} e 
   */
  const EnterKeyPressInForm = async (e) => {
    try {
      if (e.key === 'Enter') {
        await GoToLogin(e)
      }
    } catch (error) {
      await LogErrors('EnterKeyPressInForm - Login', error)
    }
  }
  //--- Eventos de formulario ---//


  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <main className='container Container-FullHeight Container-FlexContent Login-Main'>
            <div className='Login-Main__Container'>

                <p className='Login-Riactivos__Logo__Title'>Bienvenid@ a</p>
                <figure className='Login-Riactivos__Logo__ImageContainer'>
                  <img src='/img/brand/riactivos-logotipo.png' className='Login-Riactivos__Logo__ImageContainer__Image' />
                </figure>
                <p className='Login-Riactivos__Logo__Footer'>Plataforma para la evaluación diagnóstica de los aspirantes a las escuelas normales</p>

                <div className='Login-Riactivos__NewAccount'>
                  <p className='Login-Riactivos__NewAccount__Title'>Como primer paso crea una cuenta</p>
                  <p className='Login-Riactivos__NewAccount__Footer'>Esta te ayudará a llevar a cabo tu proceso de admisión</p>
                  <button type='button' onClick={() => navigate('/signup')} className='Login-Riactivos__NewAccount__Button'>{translate('labels.login.newAccount')}</button>
                </div>

                <form className='loginForm' onSubmit={FormSubmit} onKeyPress={EnterKeyPressInForm}>
                  <p id='formTitle' className='loginForm-Title'>{translate('labels.login.title')}</p>

                  <Input
                    type={'text'}
                    id={'accessCode'}
                    value={formData.accessCode}
                    onChange={InputChange}
                    placeholder="Código de acceso"
                    error={isSubmitted ? errors.accessCode : null} // Mostrar error solo si se ha enviado el formulario
                    isSubmitted={isSubmitted} // Pasar isSubmitted al Input
                    ref={accessCodeRef}
                  />

                  {isButtonLoading ? (
                    <button type='button' className='loginForm-Button loginForm-Button-Disabled'>Redirigiéndote...</button>
                  ) : (
                    <button type='submit' className='loginForm-Button'>{translate('labels.login.submit')}</button>
                  )}
                  {errors.general && <p className='loginForm-Error-Message'>{errors.general}</p>}
                </form>

                <div className='Login-Partners'>
                  <img src='/img/brand/dgesum-logotipo.png' className='Login-Partners-Logo' />
                  <img src='/img/brand/upn-logotipo.png' className='Login-Partners-Logo Login-Partners-Logo--UPN' />
                  <img src='/img/brand/edutest-logotipo.png' className='Login-Partners-Logo' />
                </div>
              </div>
          </main>

          <footer className='Login-Footer'>
            <p>{translate('labels.credits.footer')}</p>
          </footer>

          {/*
            <p className='Login-ExtraThemeSettings-Title'>Tema:</p>
            <button type='button' className='Login-ExtraThemeSettings-Buttons' onClick={() => SetRiactivosTheme()}>Riactivos</button>
            <button type='button' className='Login-ExtraThemeSettings-Buttons' onClick={() => SetMexicoTheme()}>Alternativo</button>
          */}

          <div className='Login-ExtraThemeSettings'>
            {isAdminLoginButtonLoading ? (
              <p className='Login-ExtraThemeSettings-Buttons'>Redirigiendo...</p>
            ) : (
              <button type='button' className='Login-ExtraThemeSettings-Buttons' onClick={() => GoToAdminLogin()}>Login</button>
            )}
          </div>
        </>
      )}
    </>
  )
}

export { Login };